// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../styles/common.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-menu-button_button__xDCSw {
}
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript-menu-button.module.css"],"names":[],"mappings":"AAAA;AAEA","sourcesContent":[".button {\n  composes: button from '../../styles/common.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `transcript-menu-button_button__xDCSw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`
};
module.exports = ___CSS_LOADER_EXPORT___;
